import { CallToActionSharp } from "@material-ui/icons";
import { AUTH_ACTION } from "../Actions/Constant";

let initialState = {
  isAuthenticated: false,
};

export function AuthReducer(state = initialState, action) {
  switch (action.type) {
    // clear All
    case AUTH_ACTION:
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
      };
    default:
      return state;
  }
}
